import * as React from 'react'

import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table'
import { t } from 'i18next'
import { Translation } from 'react-i18next'

import { Text } from '@chakra-ui/react'

import { ColumnHeader, DataTable } from '@enechain/ecloud-designsystem'

import { ApiKeyEndpointMetadata } from '~/gen/proto/bff/v1/model_pb'
import { MethodBadge } from '~/pages/ApiKeys/components/EndpointList/MethodBadge'

type EndpointRow = {
  method: JSX.Element
  path: JSX.Element
  description: string
}

const columnHelper = createColumnHelper<EndpointRow>()
const columns = [
  columnHelper.accessor('method', {
    cell: (info) => info.getValue(),
    header: t('pages.api_keys.role.endpoints.column.method'),
    enableSorting: false,
    meta: {
      headerStyle: { width: '100px' },
      cellStyle: { width: '100px' },
    },
  }),
  columnHelper.accessor('path', {
    cell: (info) => info.getValue(),
    header: t('pages.api_keys.role.endpoints.column.path'),
    enableSorting: false,
    meta: {
      headerStyle: { width: '45%' },
      cellStyle: { width: '45%' },
    },
  }),
  columnHelper.accessor('description', {
    cell: (info) => info.getValue(),
    header: t('pages.api_keys.role.endpoints.column.description'),
    enableSorting: false,
  }),
]

type Props = {
  endpoints: ApiKeyEndpointMetadata[]
}

export const RoleEndpointsTable: React.FC<Props> = ({ endpoints }) => {
  const data = React.useMemo(
    () =>
      endpoints.map((endpoint) => ({
        method: <MethodBadge method={endpoint.method} />,
        path: <Text fontFamily="mono">{endpoint.path}</Text>,
        description: endpoint.description,
      })),
    [endpoints],
  )
  const table = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <DataTable
      renderHeader={(header): JSX.Element => (
        <Translation key={header.column.id}>
          {(t) => (
            <ColumnHeader>
              {t(`pages.api_keys.role.endpoints.column.${header.column.id}`)}
            </ColumnHeader>
          )}
        </Translation>
      )}
      table={table}
    />
  )
}
